<template>
  <div v-if="authenticated">
    <v-card flat>
      <v-card-text style="height: 100%;">
        <v-sheet class="text-center">
          <div class="my-3">
            <!-- Comparison data iterator -->
            <v-container fluid>
              <v-data-iterator
                :items="compareList"
                items-per-page.sync="10"
                hide-default-footer
              >
                <template v-slot:default="props">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" v-for="optionItem in props.items" :key="optionItem.id">{{optionItem.name}}</th>
                        </tr>
                        <tr>
                          <th class="text-center" v-for="optionItem in props.items" :key="optionItem.id">
                            <div class="d-flex justify-center">
                              <v-img :src="getOptionImgSrc(optionItem.imgSrc)" :maxWidth="computedMaxCompareImgSize" :maxHeight="computedMaxCompareImgSize" />
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="criteriaItem in criteria" :key="criteriaItem.id">
                          <td valign="top" v-for="optionItem in props.items" :key="optionItem.id">
                            <div class="pb-0">
                              {{criteriaItem.name}}:
                            </div>
                            <div class="pt-0">
                              <CriteriaValue v-if="optionItem.criteriaValues" :keywordOnly="criteriaItem.keywordOnly" :value="optionItem.criteriaValues[criteriaItem.id]" />
                            </div>
                          </td>
                        </tr>
                        <tr v-if="comparedOptionsHaveReasons">
                          <td valign="top" v-for="optionItem in props.items" :key="optionItem.id">
                            <div class="pb-0">
                              <h3>
                                <span class="success--text">Pros</span>
                                <span class="info--text mx-1">and</span>
                                <span class="error--text">Cons</span>
                              </h3>
                            </div>
                            <div class="pt-0">
                              <div v-for="reason in optionItem.optionReasons" :key="reason.id">
                                <v-chip class="ma-2"
                                  :color="reason.isContra ? 'error' : 'success'"
                                  text-color="white"
                                >
                                  <UserAvatar
                                    class="mr-2"
                                    :email="reason.ownerName"
                                    :size="24"
                                    :color="reason.isContra ? 'red darken-4' : 'green darken-4'"
                                  />
                                    {{ reason.reasonText }}
                                </v-chip>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>

                <template v-slot:no-data>
                  <div v-if="working">Loading...</div>
                  <div v-else></div>
                </template>

              </v-data-iterator>
            </v-container>
          </div>
        </v-sheet>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import Constants from '../../constants.json'

  import * as firebase from 'firebase/app'
  // Load the auth feature into the firebase namespace.
  import 'firebase/auth'
  import 'firebase/firestore'

  import axios from 'axios'

  import CriteriaValue from '@/components/CriteriaValue.vue'

  export default {
    name: 'CompareBoard',
    components: {
      CriteriaValue
    },
    data () {
      return {
        authenticated: false,
        appId: null,
        taxon: null,
        originDomain: null,
        working: false,
        compareList: [],
        decisionCriteria: null,
        authUnsubscribeCallack: null,
        dataUnSubscribeCallback: null
      }
    },
    computed: {
      comparedOptionsHaveReasons () {
        let res = false
        for (var i = 0; i < this.compareList.length; i++) {
          const nextOption = this.compareList[i]
          if (nextOption.optionReasons && nextOption.optionReasons.length > 0) {
            res = true
            break
          }
        }
        return res
      },
      criteria () {
        let res = []
        if (this.decisionCriteria) {
          res = Object.keys(this.decisionCriteria).map( (key) => {
              const criteriaItem = { ...this.decisionCriteria[key] }
              criteriaItem.id = key
              const valueRanges = this.criteriaRanges || {}
              if (valueRanges[criteriaItem.id]) {
                criteriaItem.range = valueRanges[criteriaItem.id]
              }
              return criteriaItem
          })
        }
        res.sort((a, b) => a.order - b.order)
        return res
      },
      computedMaxCompareImgSize () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 100
          case 'sm': return 150
          default: return 200
        }
      }
    },
    mounted: async function () {
      if (this.authUnsubscribeCallack) {
        this.authUnsubscribeCallack()
        this.authUnsubscribeCallack = null
      }
      this.authUnsubscribeCallack = firebase.auth().onAuthStateChanged(() => {
        this.initAuthedState()
      })
    },
    beforeDestroy: function () {
      // Unsubscribe

      // Unsubscribe
      this.unsbscribeFromDataListeners()

      if (this.authUnsubscribeCallack) {
        this.authUnsubscribeCallack()
        this.authUnsubscribeCallack = null
      }
    },
    methods:  {
      initAuthedState: async function () {
        this.authenticated = false

        const currentUser = firebase.auth().currentUser
        if (currentUser) {
          console.log(`Have a user ${currentUser.uid}`)
          this.authenticated = true

        } else {
          console.log('DCDLY - Invalid authentication state')
          // TODO auth flow for creating an anonymous user
        }

        if (this.authenticated) {
          // TODO create or add to a board

          // Load query string params taxon, href and appId
          this.taxon = this.$route.query['taxon'] || null;
          this.appId = this.$route.query['appId'] || null;
          this.originDomain = this.$route.query['origin'] || null;

          // TODO more Validation
          if (typeof this.taxon !== 'string' ||
              typeof this.appId !== 'string' ||
              typeof this.originDomain !== 'string'
            ) {
              return
            }

          const decisionId = await this.getDecisionId()

          console.log('Compare board plugin has loaded decisoin id = ' + decisionId)

          if (decisionId) {

            // Read decisionCriteria
            const self = this
            firebase.firestore().collection("decisions").doc(decisionId).get().then((doc) => {
              if (doc.exists) {
                self.decisionCriteria = doc.data().criteria || null
              }
            }).catch((error) => {
                console.log("Error getting document:", error);
            });

            if (!this.dataUnSubscribeCallback) {
              // TODO consider conume message and post message instead of onSnapshot
              this.dataUnSubscribeCallback = firebase.firestore().collection("decisions").doc(decisionId).collection("options").where("owner", "==", currentUser.uid)
                .onSnapshot((snapshot) => {
                    snapshot.docChanges().forEach((change) => {
                      const docData = change.doc.data()
                      const itemIndex = this.compareList.findIndex(item => item.url === docData.url)
                        if (change.type === "added") {
                            // this.compareList.push(doc.data().name);
                            // console.log("Added option: ", change.doc.data());
                            if (docData.comparing && itemIndex === -1) {
                              this.compareList.push(docData);
                            }
                        }
                        if (change.type === "modified") {
                            // console.log("Modified option: ", change.doc.data());
                            if (docData.comparing && itemIndex === -1) {
                              this.compareList.push(docData);
                            } else if (!docData.comparing && itemIndex > -1) {
                              this.compareList.splice(itemIndex, 1);
                            }

                        }
                        if (change.type === "removed") {
                            // console.log("Removed option: ", change.doc.data());
                            if (itemIndex > -1) {
                              this.compareList.splice(itemIndex, 1);
                            }
                        }
                    });
                });
            }
          }
        }
      },
      getDecisionId: async function () {
        if (!this.authenticated) {
          return
        }

        let decisionId = null
        this.working = true
        // const tempDecisionKey = `${this.appId}-${this.taxon}` // One decision board per app/taxon pair
        const payload = {taxon: this.taxon, appId: this.appId}
        const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
        const decisionIdURL = `${Constants.API_BASE_PATH}/tempdecisions/id`

        const res = await axios.post(decisionIdURL, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        })

        if (res && res.status === 200 && res.data) {
          decisionId = res.data.decisionId
        }

        this.working = false

        return decisionId
      },
      unsbscribeFromDataListeners: function () {
        if (this.dataUnSubscribeCallback) {
          this.dataUnSubscribeCallback()
          // Also trigger a message to update the compare count for any subscribers to this window
          if (this.taxon && this.appId && this.containerId && this.originDomain) {
           window.parent.postMessage({taxon: this.taxon, appId: this.appId, containerId: this.containerId, compareCount: 0}, this.originDomain)
          }

          this.dataUnSubscribeCallback = null
        }
      },
      getOptionImgSrc: function (imgUrl) {
        let res = imgUrl || `${Constants.SCREENSHOT_CDN}/unknownimage.png`
        // if (res.indexOf('https:') !== 0) {
        //    res = `${Constants.SCREENSHOT_CDN}/notsecureimage.png`
        // }
        return res
      },
    }
  }
</script>

<style lang="scss">

</style>
